import { Directive, Input } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';
import { CountryConfigurationService } from '../country/country-configuration';

@Directive({
  selector: '[appDocumentValidator]',
  standalone: true,
  providers: [{ provide: NG_VALIDATORS, useExisting: DocumentValidatorDirective, multi: true }],
})
export class DocumentValidatorDirective implements Validator {
  @Input('appDocumentValidator') countryCode: string | null = null;

  constructor(private readonly countryConfigService: CountryConfigurationService) {}

  validate(control: AbstractControl): ValidationErrors | null {
    if (!control.value) return null;
    return this.countryConfigService.getDocumentValidator(this.countryCode)(control);
  }
}
